<h1 mat-dialog-title>Exit</h1>
<div mat-dialog-content>
    <p>Would you like to exit after the draft has been saved?</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="action-button" (click)="onYesClick()">Yes</button>
    <button mat-raised-button (click)="onNoClick()">No</button>
</div>